import MainPost from './components/MainPost'
import SubPost from './components/SubPost'
import CommentsSection from './components/CommentsSection'

import { useDispatch, useSelector } from 'react-redux'
import { useEffect, useState } from 'react'
import { 
  deletecomment, 
  deletecommunityPost, 
  getCommunityDetails 
} from '../../Redux/communitySlice'
import { toast } from 'react-toastify'
import { useParams } from 'react-router'
import { 
  FiRefreshCw, 
  FiLoader, 
  FiMessageSquare, 
  FiUsers,
  FiClock,
  FiCalendar,
  FiUser,
  FiEye,
  FiHeart,
  FiMessageCircle,
  FiShare2,
  FiFlag,
  FiMoreVertical,
  FiArrowLeft,
  FiHome,
  FiGrid,
  FiList,
  FiTag,
  FiFileText
} from "react-icons/fi";
import { 
  MdOutlineGroup, 
  MdOutlineRefresh, 
  MdOutlinePeople,
  MdOutlineForum,
  MdOutlineChat,
  MdOutlineFavorite,
  MdOutlineDescription,
  MdOutlineCategory,
  MdOutlineMessage,
  MdOutlineComment
} from "react-icons/md";
import { IoMdPeople, IoMdChatbubbles, IoMdHeart, IoMdHome } from "react-icons/io";
import { Link } from 'react-router-dom'

const ViewCommunity = () => {
    const dispatch = useDispatch();
    const { id } = useParams();
    const { communitySlice: { getCommunityDetailsData = {}, loading } } = useSelector(state => state)

    useEffect(() => {
        dispatch(getCommunityDetails({ id: id }))
    }, [dispatch, id])

    if (loading) {
        return (
            <div className="flex items-center justify-center min-h-[400px]">
                <div className="flex flex-col items-center gap-3">
                    <FiLoader className="w-10 h-10 text-[#715EFE] animate-spin" />
                    <p className="text-sm font-medium text-gray-500">Loading community details...</p>
                </div>
            </div>
        );
    }

    if (!getCommunityDetailsData || !getCommunityDetailsData.data) {
        return (
            <div className="flex flex-col items-center justify-center min-h-[400px] text-center">
                <div className="p-4 bg-gray-50 rounded-full mb-3">
                    <MdOutlineGroup className="w-12 h-12 text-gray-300" />
                </div>
                <p className="text-sm font-medium text-gray-500">No community details found</p>
                <Link to="/app/community" className="mt-4 text-[#715EFE] hover:text-[#855DF6] text-sm font-medium flex items-center gap-1">
                    <FiArrowLeft className="w-4 h-4" />
                    Back to Community
                </Link>
            </div>
        );
    }

    // MAIN POST (from API)
    const mainPost = {
        _id: getCommunityDetailsData._id,
        title: getCommunityDetailsData.title,
        desc: getCommunityDetailsData.desc,
        imgUrl: getCommunityDetailsData.imgUrl,
        totalLike: getCommunityDetailsData.totalLike,
        totalComment: getCommunityDetailsData.totalComment,
        isLike: getCommunityDetailsData.isLike,
        user: getCommunityDetailsData.user,
        createdAt: getCommunityDetailsData.createdAt,
        postMediaType: getCommunityDetailsData?.postMediaType || "image",
    };

    // Filter from API response
    const subPosts = getCommunityDetailsData.data?.filter(item => item.type === "post") || [];
    const allComments = getCommunityDetailsData.data?.filter(item => item.type === "comment") || [];

    const isRefresh = { id: id }

    const onDeleteSubPost = async (data) => {
        try {
            const Payload = { postId: data }
            const res = await dispatch(deletecommunityPost({ Payload, isRefresh })).unwrap()
            toast.success(res?.message || "Post deleted successfully")
        } catch (error) {
            toast.error(error?.message || "Something went wrong")
        }
    }

    const onDeleteComment = async (data) => {
        try {
            const Payload = { commentId: data }
            const res = await dispatch(deletecomment({ Payload, isRefresh })).unwrap()
            toast.success(res?.message || "Comment deleted successfully")
        } catch (error) {
            toast.error(error?.message || "Something went wrong")
        }
    }

    // Calculate statistics
    const totalPosts = 1 + subPosts.length; // Main post + sub posts
    const totalComments = allComments.length || getCommunityDetailsData.totalComment || 0;
    const totalLikes = mainPost.totalLike || 0;

    return (
        <div className="min-h-screen bg-gray-50/80">
            {/* Header Banner */}
            <div className="bg-gradient-to-r from-[#855DF6] via-[#7B5CF6] to-[#715EFE] shadow-lg relative overflow-hidden">
                <div className="absolute top-0 right-0 w-64 h-64 bg-white/5 rounded-full -mr-20 -mt-20 animate-pulse"></div>
                <div className="absolute bottom-0 left-0 w-48 h-48 bg-white/5 rounded-full -ml-12 -mb-12 animate-pulse"></div>
                <div className="absolute top-1/2 left-1/2 w-96 h-96 bg-white/5 rounded-full -translate-x-1/2 -translate-y-1/2 animate-pulse"></div>

            </div>

            {/* Main Content */}
            <section className="px-3 py-4 -mt-4 md:px-6 lg:px-10 md:py-6">
                <div className="space-y-6">
                    {/* Main Post */}
                    <div className="bg-white rounded-xl shadow-sm hover:shadow-md transition-shadow duration-300 border border-gray-100/80 overflow-hidden">
                        <MainPost post={mainPost} />
                    </div>

                    {/* Sub Posts Section */}
                    <div className="bg-white rounded-xl shadow-sm hover:shadow-md transition-shadow duration-300 border border-gray-100/80 overflow-hidden">
                        <div className="p-4 md:p-5 border-b border-gray-100 bg-gradient-to-r from-gray-50/50 to-white flex items-center justify-between">
                            <div className="flex items-center gap-3">
                                <div className="p-1.5 bg-gradient-to-br from-[#855DF6]/10 to-[#715EFE]/10 rounded-lg">
                                    <FiMessageSquare className="w-4 h-4 text-[#715EFE]" />
                                </div>
                                <div>
                                    <h2 className="text-base font-semibold text-gray-800">Sub Posts</h2>
                                    <p className="text-xs text-gray-400 hidden sm:block">
                                        {subPosts.length} sub posts
                                    </p>
                                </div>
                            </div>
                            <span className="px-2.5 py-1 text-xs font-medium text-[#715EFE] bg-[#715EFE]/10 rounded-full">
                                {subPosts.length}
                            </span>
                        </div>

                        <div className="p-4 md:p-5 space-y-4">
                            {subPosts.length > 0 ? (
                                subPosts.map(sub => (
                                    <SubPost 
                                        key={sub._id} 
                                        post={sub} 
                                        onDeleteSubPost={onDeleteSubPost} 
                                    />
                                ))
                            ) : (
                                <div className="flex flex-col items-center justify-center py-8 text-center">
                                    <div className="p-4 bg-gray-50 rounded-full mb-3">
                                        <FiMessageSquare className="w-10 h-10 text-gray-300" />
                                    </div>
                                    <p className="text-sm font-medium text-gray-500">No sub posts available</p>
                                    <p className="text-xs text-gray-400 mt-1">Sub posts will appear here</p>
                                </div>
                            )}
                        </div>
                    </div>

                    {/* Comments Section */}
                    <div className="bg-white rounded-xl shadow-sm hover:shadow-md transition-shadow duration-300 border border-gray-100/80 overflow-hidden">
                        <CommentsSection
                            comments={allComments}
                            onDeleteComment={onDeleteComment}
                            totalComment={getCommunityDetailsData.totalComment}
                        />
                    </div>
                </div>
            </section>
        </div>
    )
}

export default ViewCommunity